var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4565_214947)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7367 3.28125H8.0638C6.70352 3.28125 5.60254 4.37519 5.60254 5.72675V24.2761C5.60254 25.6277 6.70352 26.7216 8.0638 26.7216H14.5461L17.845 29.9994L21.144 26.7216H26.7327C28.093 26.7216 29.1939 25.6277 29.1939 24.2761V5.72675C29.1939 4.37519 28.093 3.28125 26.7327 3.28125H26.7367Z",
    fill: "url(#paint0_linear_4565_214947)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4968 6.29409V4.8474C32.4968 2.17202 30.3147 0 27.6181 0H7.17809C4.48546 0.00396354 2.30343 2.17202 2.30343 4.85137V6.29806C1.32611 6.53587 0.600098 7.40388 0.600098 8.44629V21.5696C0.600098 22.612 1.32611 23.48 2.30343 23.7178V25.1645C2.30343 27.8399 4.48546 30.0119 7.18208 30.0119H13.3492C13.5447 30.0119 13.7202 29.9524 13.8598 29.8533C14.2786 29.56 14.3943 28.9219 13.9755 28.5057C13.9236 28.4542 13.8678 28.4106 13.8079 28.375C13.6723 28.2917 13.5127 28.2481 13.3492 28.2481H7.18208C5.46677 28.2481 4.07857 26.8688 4.07857 25.1645V4.85137C4.07857 3.14705 5.46677 1.76774 7.18208 1.76774H27.6221C29.3374 1.76774 30.7256 3.14705 30.7256 4.85137V25.1605C30.7256 26.8648 29.3374 28.2442 27.6221 28.2442H22.3446C22.2089 28.2442 22.0773 28.2759 21.9576 28.3314C21.8699 28.375 21.7861 28.4304 21.7143 28.5018C21.3991 28.8149 21.3872 29.2509 21.5787 29.5719C21.7263 29.8216 21.9975 30.004 22.3406 30.004H27.6181C30.3107 30.004 32.4968 27.8359 32.4968 25.1566V23.7099C33.4741 23.4721 34.2001 22.604 34.2001 21.5616V8.44233C34.2001 7.39992 33.4741 6.53191 32.4968 6.29409Z",
    fill: "url(#paint1_linear_4565_214947)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.4559 7.94585H9.344C9.13657 7.94585 8.9411 7.89036 8.77755 7.79524C8.43449 7.60103 8.20312 7.23242 8.20312 6.81228C8.20312 6.53483 8.30285 6.28117 8.47039 6.08299C8.67783 5.83725 8.99296 5.67871 9.344 5.67871H25.4519C25.767 5.67871 26.0503 5.80554 26.2577 6.01165C26.4651 6.21775 26.5928 6.49916 26.5928 6.81228C26.5928 7.04217 26.525 7.25223 26.4093 7.43059C26.2058 7.73975 25.8548 7.94585 25.4559 7.94585Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M26.7365 3.28125H8.06366C6.70339 3.28125 5.6024 4.37519 5.6024 5.72675V24.2761C5.6024 25.6277 6.70339 26.7216 8.06366 26.7216H14.5459L17.8449 29.9994L21.1438 26.7216H26.7325C28.0928 26.7216 29.1938 25.6277 29.1938 24.2761V5.72675C29.1938 4.37519 28.0928 3.28125 26.7325 3.28125H26.7365ZM28.017 24.2801C28.017 24.9816 27.4426 25.5524 26.7365 25.5524H20.6572L17.8449 28.3466L15.0326 25.5524H8.06366C7.35759 25.5524 6.78317 24.9816 6.78317 24.2801V5.72675C6.78317 5.02521 7.35759 4.45446 8.06366 4.45446H26.7325C27.4386 4.45446 28.013 5.02521 28.013 5.72675V24.2761L28.017 24.2801ZM13.9755 28.5012C14.3943 28.9174 14.2747 29.5555 13.8598 29.8488C13.7202 29.9479 13.5486 30.0074 13.3492 30.0074H7.18208C4.48945 30.0074 2.30343 27.8393 2.30343 25.16V23.7133C1.32611 23.4755 0.600098 22.6074 0.600098 21.565V14.8627C1.70108 15.3542 2.8619 15.8021 4.07458 16.1944V25.16C4.07458 26.8643 5.46278 28.2436 7.17809 28.2436H13.3452C13.5088 28.2436 13.6683 28.2872 13.8039 28.3704C13.8638 28.4061 13.9196 28.4497 13.9715 28.5012H13.9755ZM30.7256 16.1944V25.16C30.7256 26.8643 29.3374 28.2436 27.6221 28.2436H22.3446C22.2089 28.2436 22.0773 28.2753 21.9576 28.3308C21.8699 28.3744 21.7861 28.4299 21.7143 28.5012C21.3991 28.8143 21.3872 29.2503 21.5787 29.5714C21.7263 29.8211 21.9975 30.0034 22.3406 30.0034H27.6181C30.3107 30.0034 32.4968 27.8354 32.4968 25.156V23.7093C33.4741 23.4715 34.2001 22.6035 34.2001 21.5611V14.8587C33.0991 15.3502 31.9383 15.7981 30.7256 16.1905V16.1944Z",
    fill: "url(#paint2_linear_4565_214947)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M17.3981 18.2091C13.1856 18.2091 9.18856 17.6463 5.59839 16.6475V24.2773C5.59839 25.6288 6.69937 26.7228 8.05965 26.7228H14.5419L17.8409 30.0006L21.1398 26.7228H26.7285C28.0888 26.7228 29.1898 25.6288 29.1898 24.2773V16.6475C25.5996 17.6463 21.6066 18.2091 17.3901 18.2091H17.3981Z",
    fill: "url(#paint3_linear_4565_214947)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6668 17.7378L15.5591 20.5083L16.9991 18.7643L15.6668 17.7378Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5213 9.18832C21.2196 10.1079 13.7919 13.1836 10.9796 14.3488C10.6086 14.5034 10.6326 15.0345 11.0195 15.1534L14.2427 16.1523L21.4709 11.7963C21.5148 11.7686 21.5587 11.828 21.5228 11.8637L15.9979 17.0837C15.9979 17.0837 19.3966 19.5569 21.0082 20.7222C21.4071 21.0115 21.9695 20.7896 22.0573 20.31C22.52 17.8605 23.6769 11.7329 24.0758 9.6362C24.1356 9.32308 23.8205 9.06545 23.5213 9.18436V9.18832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4565_214947",
    x1: 5.60254,
    y1: 16.6423,
    x2: 29.1979,
    y2: 16.6423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0866BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DBBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4565_214947",
    x1: 0.600098,
    y1: 15.002,
    x2: 34.2001,
    y2: 15.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0866BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DBBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4565_214947",
    x1: 0.600098,
    y1: 0.00340586,
    x2: 34.2001,
    y2: 0.00340586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0866BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DBBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4565_214947",
    x1: 0.600074,
    y1: 23.326,
    x2: 0.998982,
    y2: 23.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0866BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DBBF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4565_214947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.fd7c5d83e27cb287d90a532a686460cf.svg";
export { ForwardRef as ReactComponent };